module.exports = __webpack_public_path__ + "img/image162.42391ef0.jpg";